import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPhotosUpload from "@/pages/admin/AdminPhotosUpload";

export const Route = createFileRoute("/admin/photos/")({
  head: () => pageHead("Admin \u2014 Photos \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPhotosUpload,
});
